module.exports = __webpack_public_path__ + "images/57987be4eb98b4c77644d93d92df80fa.svg";